export default __webpack_public_path__ + "static/media/(86).373123e1.jpg";